import { Component } from '@angular/core';
import { SecretService } from '../../services/secret.service';
import packageJson from '../../../../../package.json';
import {Settings} from '@ct-client';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    templateUrl: 'credits.component.html',
    styleUrls: ['credits.component.scss']
})
export class CreditsModalComponent {

    public version = packageJson.version;
    constructor(
        public dialogRef: MatDialogRef<CreditsModalComponent>,
        private secretService: SecretService
    ) { }

    public discard(): void {
        this.dialogRef.close();
    }

    get termsLink(): string {
        return this.getLink(this.secretService.getPortalSettings(), 'sPrivacyPolicyLink');
    }

    get privacyLink(): string {
        return this.getLink( this.secretService.getPortalSettings(),  'sPrivacyPolicyLink');
    }

    private getLink(setting: Settings, linkName: string) {
        if (!setting || !setting[linkName]) {
            return '';
        }

        const url = setting[linkName];
        if (url.indexOf('http:') >= 0 || url.indexOf('https:') >= 0) {
            return url;
        } else {
            return `https://${url}`;
        }
    }
}

